import uniq from 'lodash-es/uniq';
import { config as TestWidgetConfig } from './testWidget/config';
import { config as ParaCordConfig } from './paraCord/config';
import { config as UsMapConfig } from './usMap/config';
import { config as WorldMapConfig } from './worldMap/config';
import { config as DonutGraphConfig } from './donutGraph/config';
import { config as CirclePackConfig } from './circlePack/config';
import { config as CustomPackConfig } from './customCirclePack/customPackConfig';
import { config as TableConfig } from './table/config';
import { config as TypographConfig } from './typograph/config';
import { config as StackedBarConfig } from './stackedBarChart/config';
import { stackedConfig as StackedTimelineConfig} from "./timeline/config";
import { config as TimelineConfig } from './timeline/config';
import { config as PolarAreaConfig } from './polarArea/config';
import { config as MetricsConfig } from './metrics/config';
import { config as MultiDonutConfig } from './donutGraph/multiConfig';
import { config as LineChartConfig } from './lineChart/config';
import { config as EarthMapConfig } from './earthMap/config';
import { config as MatrixConfig } from './matrix/config';
import { config as TreeMapConfig } from './treemap/config';
import { config as BipartiteGraphConfig } from './nodeLink/edgeGraphConfig';
import { config as ClusterGraphConfig } from './nodeLink/clusterGraphConfig';
import { config as NetworkGraphConfig } from './nodeLink/nodeGraphConfig';
import { config as ChoroplethMapConfig } from './choroplethMap/config';
import { config as WordCloudConfig } from './wordCloud/config'
import { config as MeterConfig} from './meter/config';

/**
 * Types of widgets
 * Remarks: Ideally, enums should named singular (i.e. WidgetType) but
 * this was an existing const and is referenced in many places
 */
export enum WIDGET_TYPES {
	BIPARTITE_GRAPH = 'BIPARTITE_GRAPH',
	CIRCLE_PACK = 'CIRCLE_PACK',
	CLUSTER_GRAPH = 'CLUSTER_GRAPH',
	CUSTOM_CIRCLE_PACK = 'CUSTOM_CIRCLE_PACK',
	DONUT_GRAPH = 'DONUT_GRAPH',
	EARTH_MAP = 'EARTH_MAP',
	CHOROPLETH_MAP = 'CHOROPLETH_MAP',
	LINE_CHART = 'LINE_CHART',
	MAP = 'MAP',
	MATRIX = 'MATRIX',
	METER = 'METER',
	METRICS = 'METRICS',
	MULTI_DONUT = 'MULTI_DONUT',
	NETWORK_GRAPH = 'NETWORK_GRAPH',
	PARACORD = 'PARACORD',
	POLAR_AREA = 'POLAR_AREA',
	STACKED_BAR_GRAPH = 'STACKED_BAR_GRAPH',
	STACKED_TIMELINE = 'STACKED_TIMELINE',
	TABLE = 'TABLE',
	TEST_WIDGET = 'TEST_WIDGET',
	TIMELINE = 'TIMELINE',
	TREE_MAP = 'TREE_MAP',
	TYPOGRAPH = 'TYPOGRAPH',
	US_MAP = 'US_MAP',
	WORLD_MAP = 'WORLD_MAP',
	WORD_CLOUD = 'WORD_CLOUD',
}

export const WIDGETS = {
	[WIDGET_TYPES.BIPARTITE_GRAPH]: BipartiteGraphConfig,
	[WIDGET_TYPES.CIRCLE_PACK]: CirclePackConfig,
	[WIDGET_TYPES.CLUSTER_GRAPH]: ClusterGraphConfig,
	[WIDGET_TYPES.CUSTOM_CIRCLE_PACK]: CustomPackConfig,
	[WIDGET_TYPES.DONUT_GRAPH]: DonutGraphConfig,
	[WIDGET_TYPES.EARTH_MAP]: EarthMapConfig,
	[WIDGET_TYPES.CHOROPLETH_MAP]: ChoroplethMapConfig,
	[WIDGET_TYPES.LINE_CHART]: LineChartConfig,
	[WIDGET_TYPES.MATRIX]: MatrixConfig,
	[WIDGET_TYPES.METER]: MeterConfig,
	[WIDGET_TYPES.METRICS]: MetricsConfig,
	[WIDGET_TYPES.MULTI_DONUT]: MultiDonutConfig,
	[WIDGET_TYPES.NETWORK_GRAPH]: NetworkGraphConfig,
	[WIDGET_TYPES.PARACORD]: ParaCordConfig,
	[WIDGET_TYPES.POLAR_AREA]: PolarAreaConfig,
	[WIDGET_TYPES.STACKED_BAR_GRAPH]: StackedBarConfig,
	[WIDGET_TYPES.STACKED_TIMELINE]: StackedTimelineConfig,
	[WIDGET_TYPES.TEST_WIDGET]: TestWidgetConfig,
	[WIDGET_TYPES.TABLE]: TableConfig,
	[WIDGET_TYPES.TIMELINE]: TimelineConfig,
	[WIDGET_TYPES.TREE_MAP]: TreeMapConfig,
	[WIDGET_TYPES.TYPOGRAPH]: TypographConfig,
	[WIDGET_TYPES.US_MAP]: UsMapConfig,
	[WIDGET_TYPES.WORLD_MAP]: WorldMapConfig,
	[WIDGET_TYPES.WORD_CLOUD]: WordCloudConfig,
};

/**
 * Returns all of the widgets.
 * @param configurations possibly null or empty set of configurations as overrides
 * @param order the order in which the widgets should show up, unlisted charts will be added to the end.
 */
export const allWidgets = (configurations, order = []) => {
	let names = uniq(order.concat(Object.keys(WIDGETS)));

	let widgets = names.map((name) => ({
		key: name,
		configurations: [],
	}));

	widgets.forEach((widget) => {
		const config = configurations[widget.key];
		if (config) {
			widget.configurations = config.configurations;
		}
	});
	return widgets;
};

/**
 * Returns all the widgets except for those in the given list of keys.
 * @param keys
 * @param configurations
 * @param order
 */
export const filterOutWidgets = (keys, configurations, order) => {
	return allWidgets(configurations, order).filter((widget) => {
		return keys.indexOf(widget.key) < 0;
	});
};

/**
 * Returns only the widgets that match the given list of keys.
 * @param keys
 * @param configurations
 * @param order
 */
export const filterInWidgets = (keys, configurations, order) => {
	return allWidgets(configurations, order).filter((widget) => {
		return keys.indexOf(widget.key) >= 0;
	});
};
